import { Box, styled, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import clsx from 'clsx';
import { useResize } from '../../hooks/resize';
import { TabBox } from '../styles/Styles';

interface Props {}

export const ClassStat: React.FC<Props> = () => {
  const { isMobile } = useResize();
  const navigate = useNavigate();
  const location = useLocation();
  const [userStatData, setUserStatData] = useState<any>(location.state);
  const [value, setValue] = useState<number>(1);

  useEffect(() => {
    if (location.state) {
      setUserStatData(location.state);
    }
    const path = window.location.pathname;
    setValue(1);
  }, [window.location.pathname]);

  return (
    <div className={clsx({ root: !isMobile() }, { root_resize: isMobile() })}>
      <Helmet>
        <title>학급 통계</title>
      </Helmet>
      <Outlet />
    </div>
  );
};
